//#region src/domain/i18n/document-id-length.ts
var DocumentIdLength = /* @__PURE__ */ function(DocumentIdLength) {
	DocumentIdLength[DocumentIdLength["DO"] = 11] = "DO";
	DocumentIdLength[DocumentIdLength["GT"] = 13] = "GT";
	DocumentIdLength[DocumentIdLength["HN"] = 13] = "HN";
	DocumentIdLength[DocumentIdLength["PE"] = 8] = "PE";
	return DocumentIdLength;
}({});
//#endregion
export { DocumentIdLength };

//# sourceMappingURL=document-id-length.js.map